import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dashboard from "../assets/img/dashboard-alt-new.jpg";
import Section from "../components/common/Section";
import { Button, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import bgl from "../assets/img/bg-landing-old.jpg";

const Hero = () => {
  return (
    <Section
      className="py-5 overflow-hidden"
      data-bs-theme="light"
      image={bgl}
      position="center bottom"
      overlay
      style={{overflowX:'hidden'}}
    >
      <Row className="justify-content-center align-items-center pt-5 pb-5"
      style={{minHeight:'650px'}}
      
      >
        {/* Text Content */}
        <Col
          xs={12}
          md={10}
          lg={6}
          className="text-center text-lg-start mb-4 mb-lg-0"
        >
          <h2 className="text-white fw-light text-capitalize">
            <br />
            Property Managers
            <br />
            Get More Done 
            <br />

            with CONDOZAK™
          </h2>
          <p className="lead text-white opacity-75 mt-3" style={{maxWidth:'400px'}}>
            Streamline property administration, simplify communication, and
            enhance resident satisfaction from one powerful property management
            platform.
          </p>
          <Button
            as={Link}
            variant="outline-light"
            size="lg"
            className="border-2 rounded-pill mt-4 fs-9 py-2 px-4"
            to="/contact-us"
          >
            Book Demo
            <FontAwesomeIcon icon="play" transform="shrink-6 down-1 right-5" />
          </Button>
        </Col>

        {/* Image */} 
        <Col xs={12} md={10} lg={6} className="text-center">
          <Link to="/">
            <img
              className="img-fluid rounded w-100"
              src={dashboard}
              alt="Dashboard preview"
              style={{ maxHeight: "650px", objectFit: "contain" }}
            />
          </Link>
        </Col>
      </Row>
    </Section>
  );
};

export default Hero;

// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import dashboard from "../assets/img/dashboard-alt-new.png";
// import Section from "../components/common/Section";
// import { Button, Col, Row } from "react-bootstrap";
// import { Link } from "react-router-dom";

// import bgl from "../assets/img/bg-landing-old.jpg";
// const Hero = () => {

//   return (
//     <Section
//       className="py-3 overflow-hidden"
//       data-bs-theme="light"
//       image={bgl}
//       position="center bottom"
//       overlay
//     >
//       <Row className="justify-content-center align-items-start pt-8 pt-lg-10 pb-lg-9 pb-xl-0">
//         <Col
//           md={11}
//           lg={8}
//           xl={4}
//           className="pb-5 pb-xl-7 text-center text-xl-start"
//         >
//           <h2 className="text-white fw-light text-capitalize">
//             Property Managers
//             Get More Done with CONDOZAK™
//           </h2>
//           <p className="lead text-white opacity-75 mt-3">
//           Streamline property administration, simplify communication, and enhance resident satisfaction from one powerful property management platform.
//           </p>
//           <Button
//             as={Link}
//             variant="outline-light"
//             size="lg"
//             className="border-2 rounded-pill mt-4 fs-9 py-2"
//             to="/contact-us"
//           >
//             Book Demo
//             <FontAwesomeIcon icon="play" transform="shrink-6 down-1 right-5" />
//           </Button>
//         </Col>

//         <Col
//           // xl={{ span: 7 }}
//           className="d-flex align-items-center mt-4 mt-xl-0"
//         >
//           <Link to="/">
//             <img className="img-fluid rounded" src={dashboard} alt="" />
//           </Link>
//         </Col>
//       </Row>
//     </Section>
//   );
// };

// export default Hero;

// <Row className="justify-content-center align-items-center pt-8 pt-lg-10 pb-lg-9 pb-xl-0">
//         <Col
//           md={11}
//           lg={8}
//           xl={4}
//           className="pb-7 pb-xl-9 text-center text-xl-start bg-danger"
//         >
//           <h1 className="text-white fw-light">
//             Bring <span className="fw-bold">perfection</span>
//             <br />
//             to your Property Management
//           </h1>
//           <p className="lead text-white opacity-75">
//             Revolutionize Your Property Management with CONDOZAK - Cutting-Edge
//             Software for Enhanced Productivity!
//           </p>
//           <Button
//             as={Link}
//             variant="outline-light"
//             size="lg"
//             className="border-2 rounded-pill mt-4 fs-9 py-2"
//             to="/contact-us"
//           >
//             Request a Demo
//             <FontAwesomeIcon icon="play" transform="shrink-6 down-1 right-5" />
//           </Button>
//         </Col>
//         <Col
//           xl={{ span: 7, offset: 1 }}
//           className="align-self-end mt-4 mt-xl-0"
//         >
//           <Link to="/" className="img-landing-banner">
//             <img className="img-fluid" src={dashboard} alt="" />
//           </Link>
//         </Col>
//       </Row>
